const isGDPR = () => window.evidon.notice.isGDPR();

export default isGDPR;
